import { Stack } from "@mui/material"
import useSettings from "minimals-template/components/@hooks/useSettings"
import { FitInRemainingSpace } from "lib/@components/fit-in-remaining-space"
import { TOOLBAR_MAX_WIDTH } from "lib/@components/toolbarBox"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Mobiliser } from "routes/asset-register/plugins/asset-mapping/mobiliser"
import { LegacyMappingProgress } from "routes/asset-register/plugins/asset-mapping/legacy-mapping-progress"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser-advanced-mapping.runtime"

export function Mapping({ mappingType }) {
    const isManualMapTab = mappingType === "manual"
    const { themeStretch } = useSettings()
    const unstretchedWidth = themeStretch ? undefined : TOOLBAR_MAX_WIDTH
    const { target } = useBoundContext()
    const upgradesEnabled = isEnabled(FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING)

    return (
        <Bound isManualMapTab={isManualMapTab} target={target} register={target}>
            <FitInRemainingSpace leaveSpace={24} sx={{ mt: 2 }}>
                <Stack sx={{ mt: 1, pb: 2, width: 1, mx: "auto", maxWidth: unstretchedWidth }}>
                    <If value={upgradesEnabled}>
                        <Stack spacing={1}>
                            <Mobiliser $lazy />
                        </Stack>
                        <Else>
                            <LegacyMappingProgress />
                        </Else>
                    </If>
                </Stack>
            </FitInRemainingSpace>
        </Bound>
    )
}
